import { ScrollReveal } from '@/components/effects/ScrollReveal';
import { LiveThreatIntelligence } from '@/components/defend/LiveThreatIntelligence';

export const TerminalSection = () => {
  return (
    <section
      id="defend"
      data-testid="terminal-section"
      className="py-14 sm:py-20"
      style={{ background: 'var(--l1)' }}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <LiveThreatIntelligence />
        </ScrollReveal>
      </div>
    </section>
  );
};
